<div class="tile__status" data-testid="tile"
     [ngClass]="{ 'tile__status--active': tile.params.firingUp === 1,
        'tile__status--inactive': tile.params.firingUp !== 1 }">
    <div class="icon-wrapper">
        <svg-icon src="/assets/img/icons/sprocket.svg"
                  *ngIf="tile.params.firingUp !== 1">
        </svg-icon>
        <svg-icon src="/assets/img/icons/sprocket_active.svg"
                  [class]="'rotate'"
                  *ngIf="tile.params.firingUp === 1">
        </svg-icon>
    </div>
    <div class="tile__subtitle">
        <floating-subtitle *ngIf="tile.params.firingUp === 1"
                           [text]="subtitle(1317)">
        </floating-subtitle>
        <floating-subtitle *ngIf="tile.params.firingUp !== 1"
                           [text]="subtitle(1318)">
        </floating-subtitle>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
